/* eslint-disable import/prefer-default-export */

import { createSelector } from 'reselect';
import { numberToCurrency } from '../utils/currency';

const getCountries = (state) => state.config.countries;
const getCurrentCountry = (state) => state.request.country.tld;
const getLocale = (state) => state.request.locale;
const getUserReferralDetails = (state) => state.user.roovite;

export const getMGMDetails = createSelector(
  [getCountries, getCurrentCountry, getLocale, getUserReferralDetails],
  (countries, currentCountry, locale, userReferralDetails) => {
    const {
      referrerAmount,
      referrerSteps,
      inviteeAmount,
      inviteeSteps,
      currencySymbol,
      currencyCode,
      creditExpiry,
      minimumOrderValue,
    } = countries.find((country) => country.id === currentCountry).roovite;
    const showDecimals = currentCountry === 'kw';

    let referralHref;
    let referralLink;
    let referralCode;

    if (userReferralDetails && userReferralDetails.link) {
      referralHref = userReferralDetails.link;
      [referralCode] = userReferralDetails.link.split('/').slice(3);
      referralLink = userReferralDetails.link.replace('https://', '');
    }

    return {
      referrerAmount: numberToCurrency(
        referrerAmount,
        locale,
        currencySymbol,
        currencyCode,
        showDecimals,
      ),
      inviteeAmount: numberToCurrency(
        inviteeAmount,
        locale,
        currencySymbol,
        currencyCode,
        showDecimals,
      ),
      inviteeSteps,
      referrerSteps,
      creditExpiry,
      referralHref,
      referralLink,
      referralCode,
      minimumOrderValue: numberToCurrency(
        minimumOrderValue,
        locale,
        currencySymbol,
        currencyCode,
        showDecimals,
      ),
    };
  },
);
